import React from 'react';

import RichText from 'components/RichText/RichText';
import { useCopyStore } from 'store';

import * as S from './DoubleColumnSection.styles';

export interface DoubleColumnSectionProps {
  label: string;
  categories: { id?: number; text: string }[];
  activeLabel?: boolean;
  onClickLabel?: () => void;
  onClickContent?: (e: any) => void;
}

const DoubleColumnSection: React.FunctionComponent<
  DoubleColumnSectionProps
> = ({
  label,
  categories,
  activeLabel,
  onClickLabel,
  onClickContent,
  ...rest
}) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);

  const hoverTextColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  return (
    <S.Wrapper {...rest}>
      <S.Container
        activeLabel={activeLabel}
        hoverTextColor={hoverTextColor}
        onClick={onClickLabel}
      >
        {label && (
          <RichText
            as="h4"
            size="heading4"
            richText={label}
            defaultFormatting
          />
        )}
      </S.Container>

      <S.Categories onClick={onClickContent}>
        {categories?.map(({ id, text }) => (
          <RichText key={id} richText={text} />
        ))}
      </S.Categories>
    </S.Wrapper>
  );
};

export default DoubleColumnSection;
